import { render } from "./selectCinema.vue?vue&type=template&id=18ed8ee0&scoped=true"
import script from "./selectCinema.vue?vue&type=script&lang=js"
export * from "./selectCinema.vue?vue&type=script&lang=js"

import "./selectCinema.vue?vue&type=style&index=0&id=18ed8ee0&scoped=true&lang=css"

import exportComponent from "/root/workspace/cinema-admin_TXA8/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18ed8ee0"]])

export default __exports__